<template>
  <transition name="fade">
    <div v-if="toastPopupVisible && displayMessage">
      <b-card no-body style="border-radius: 0 !important; background-color: #FFEFD8; color: #AC6C0E;">
        <b-card-body style="padding: 0.5rem 0.1rem;">
          <b-row style="width: 100%">
            <b-col class="align-content-center d-flex col-lg-10 col-md-12 col-sm-12">
              <div id="scroll-container" style="width: 100%; align-content: center">
                <div id="scroll-text">
                  <h6 class="mb-0 text-right pl-0" style="margin-right: 7rem; font-weight: bold; white-space: nowrap;">
                    <font-awesome-icon :icon="['far', 'triangle-exclamation']"/>
                    {{ text }}
                  </h6>
                </div>

              </div>
            </b-col>
            <b-col class="col-lg-2 col-md-12 col-sm-12 align-content-center d-flex p-0 justify-content-end">
              <div class="justify-center h-100">
                <label class="h-100 justify-center align-content-center custom-checkbox">
                  <input type="checkbox" v-model="isChecked">
                  <p class="justify-center m-0 pl-0 pr-0 pb-0" style="padding-top: 1px">
                    {{$tr('MaintenanceNotice.DoNotShow',"Don't show again")}}
                  </p>
                </label>
              </div>
              <div class="justify-content-center h-100 align-content-center">
                <b-button-close class="d-flex close-button" @click="closePopupToastWindow()">
                  <span class="close-icon">×</span>
                </b-button-close>
              </div>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </div>
  </transition>
</template>

<script>
import {registerPopupComponent} from "@/components/notifications/LocalNotification";

export default {
  name: "MaintenanceNotice",
  components: {},

  async beforeMount() {
  },

  async mounted() {
    this.displayMessage = localStorage.getItem('maintenanceNoticeState');
    this.displayMessage = (!this.displayMessage || this.displayMessage === "true");

    let result = await this.getInfoForNotification();
    if (result === null) {
      this.isChecked = undefined;
      return;
    }

    if (SessionManager.isLoggedIn() && this.displayMessage) {

      await this.showPopupToast();
    } else if (!SessionManager.isLoggedIn()) {

      localStorage.setItem('maintenanceNoticeState', !this.isChecked);
      await this.showPopupToast();
    }
  },

  methods: {
    async getInfoForNotification() {
      let result = await Rpc.Notifications.getInfoAboutNotification();
      if (result === null) {
        return null;
      }
      let selectedLang = AppTranslations.selectedLang;
      for (let messageLang in result.messages) {
        if (messageLang === selectedLang) {
          this.displayFrom = "";
          this.displayTo = "";
          this.text = result.messages[messageLang].message;
          return "Success";
        }
      }
    },

    waitForAnimations(fast = false) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, fast ? 600 : 1500);
      });
    },

    async showPopupToast() {
      this.toastPopupVisible = true;
      this.displayMessage = true;
      this.isChecked = false;
      await this.waitForAnimations();
    },

    async closePopupToastWindow() {
      this.toastPopupVisible = false;
      await this.waitForAnimations();
    },
  },
  watch: {
    isChecked: function (val, oldVal) {
      localStorage.setItem('maintenanceNoticeState', !val);
    },
  },

  data: () => ({
    listOfTheLatestNotifications: [],
    numberOfNotificationsOnBell: 5,
    toastPopupVisible: false,
    queueOfPopupNotifications: [],
    maintenanceNotice: null,
    displayMessage: false,
    displayFrom: null,
    displayTo: null,
    text: null,
    isChecked: false,
  }),
};
</script>

<style scoped>
@media screen and (max-width: 1000px) {

  #scroll-container {
    border-radius: 5px;
    overflow: hidden;
  }

  #scroll-text {
    -moz-transform: translateX(100%);
    -webkit-transform: translateX(100%);
    transform: translateX(100%);

    -moz-animation: animation 60s linear infinite;
    -webkit-animation: animation 60s linear infinite;
    animation: animation 60s linear infinite;
  }

  /* for Firefox */
  @-moz-keyframes animation {
    from {
      -moz-transform: translateX(100%);
    }
    to {
      -moz-transform: translateX(-280%);
    }
  }

  /* for Chrome */
  @-webkit-keyframes animation {
    from {
      -webkit-transform: translateX(100%);
    }
    to {
      -webkit-transform: translateX(-280%);
    }
  }

  @keyframes animation {
    from {
      -moz-transform: translateX(100%);
      -webkit-transform: translateX(100%);
      transform: translateX(100%);
    }
    to {
      -moz-transform: translateX(-280%);
      -webkit-transform: translateX(-280%);
      transform: translateX(-280%);
    }
  }
}

@media screen and (min-width: 1000px) and (max-width: 1500px) {

  #scroll-container {
    border-radius: 5px;
    overflow: hidden;
  }

  #scroll-text {
    -moz-transform: translateX(90%);
    -webkit-transform: translateX(90%);
    transform: translateX(90%);

    -moz-animation: animation 60s linear infinite;
    -webkit-animation: animation 60s linear infinite;
    animation: animation 60s linear infinite;
  }

  /* for Firefox */
  @-moz-keyframes animation {
    from {
      -moz-transform: translateX(90%);
    }
    to {
      -moz-transform: translateX(-20%);
    }
  }

  /* for Chrome */
  @-webkit-keyframes animation {
    from {
      -webkit-transform: translateX(90%);
    }
    to {
      -webkit-transform: translateX(-100%);
    }
  }

  @keyframes animation {
    from {
      -moz-transform: translateX(90%);
      -webkit-transform: translateX(90%);
      transform: translateX(90%);
    }
    to {
      -moz-transform: translateX(-100%);
      -webkit-transform: translateX(-100%);
      transform: translateX(-100%);
    }
  }
}

@media screen  and (min-width: 1500px) {
  .custom-h6 {
    padding-left: 12rem !important;
  }
}

.close-button {
  background-color: #AC6C0E;
  border: none;
  color: white;
  width: 18px !important;
  min-width: 18px !important;
  height: 18px;
  align-items: center;
  opacity: 1;
  justify-content: center;
  border-radius: 4px;
  margin-left: 10px;
}

.close-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 1.5rem;
  padding-right: 1px;
  font-family: serif;
}

.custom-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-items: center;
  font-weight: bold;
  margin: 0;
}

.custom-checkbox input[type="checkbox"] {
  appearance: none;
  width: 18px;
  height: 18px;
  border: 2px solid #AC6C0E;
  border-radius: 4px;
  margin-right: 10px;
  position: relative;
}

.custom-checkbox input[type="checkbox"]:checked {
  background-color: #AC6C0E;
  border-color: #AC6C0E;
}

.custom-checkbox input[type="checkbox"]:checked::after {
  content: '';
  position: absolute;
  left: 4px;
  width: 6px;
  height: 12px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
</style>
